import './Section.css';

const Section = (props) => {
  const classes = `${props.className}`;
  return <section className={classes}>{props.children}</section>
};

export default Section;
